// ChatHeader.js
import React, { useState } from "react";
import { Avatar, IconButton, Stack, Typography, Paper, Tooltip } from "@mui/material";
import { IoChevronBack } from "react-icons/io5";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";
import { useSelector } from "react-redux";
import ClientShowMembersModal from "../ShowMembersModal";
import { BIBlue } from "../../../assets/helpers";

const ChatHeader = ({ selectedChat, onBack, isSmallScreen, clientId, selectedClientData: propClientData }) => {
  const { multiLanguageData, selectedClientData: reduxClientData } = useSelector((state) => state?.main);
  const selectedClientData = propClientData || reduxClientData;
  const currentClientId = clientId || selectedClientData?.ClientId || selectedChat?.clientId;
  const LANGUAGE = ClientEnglishFallback.ClientChat(multiLanguageData?.ClientChat || {});
  const { TEXT_CHAT } = LANGUAGE;
  const [showMembersModal, setShowMembersModal] = useState(false);

  return (
    <>
      <Paper
        elevation={2}
        sx={{
          display: "flex",
          alignItems: "center",
          p: 1.5,
          bgcolor: "#ffffff",
          borderRadius: "16px 16px 0 0",
          borderBottom: "1px solid #f0f0f0",
          position: "sticky",
          top: 0,
          zIndex: 10,
          width: "100%",
          boxSizing: "border-box"
        }}>
        <Stack
          direction="row"
          sx={{ alignItems: "center", justifyContent: "space-between", width: "100%" }}>
          <Stack direction="row" sx={{ alignItems: "center" }} spacing={1.5}>
            {isSmallScreen && (
              <IconButton onClick={onBack} sx={{ color: "#555", mr: 0.5 }}>
                <IoChevronBack size={24} />
              </IconButton>
            )}
            <Avatar
              src={selectedChat?.groupIcon}
              sx={{
                width: 44,
                height: 44,
                border: "1px solid #eee"
              }}
            />
            <Typography variant="subtitle1" sx={{ color: "#333", fontWeight: "700" }}>
              {selectedChat?.groupName || TEXT_CHAT}
            </Typography>
          </Stack>

          {/* Right side Members Button */}
          <Tooltip title="Group Members">
            <IconButton
              onClick={() => setShowMembersModal(true)}
              sx={{
                color: "text.secondary",
                "&:hover": {
                  color: BIBlue,
                  bgcolor: `${BIBlue}10`
                }
              }}>
              <PeopleAltOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      </Paper>

      {/* Group Members Modal */}
      {showMembersModal && (
        <ClientShowMembersModal
          open={showMembersModal}
          onClose={() => setShowMembersModal(false)}
          selectedChat={selectedChat}
          clientId={currentClientId}
          selectedClientData={selectedClientData}
        />
      )}
    </>
  );
};

export default ChatHeader;
